// Vimeo and Youtube iframe //
document.addEventListener('DOMContentLoaded', () => {
  // Function to handle video embedding
  function initializeVideoPlayer({
    platform,
    videoElement,
    videoId,
    videoIdMobile,
    embedContainer,
    playBtn,
    closeBtn,
  }) {
    let player;

    playBtn.addEventListener('click', function () {
      const iframe = document.createElement('iframe');
      const isMobile = window.innerWidth < 1024;
      const videoSrc =
        platform === 'youtube'
          ? `https://www.youtube.com/embed/${isMobile && videoIdMobile ? videoIdMobile : videoId}?enablejsapi=1&autoplay=1&mute=0&controls=1`
          : `https://player.vimeo.com/video/${isMobile && videoIdMobile ? videoIdMobile : videoId}?autoplay=1&muted=0&controls=1&title=0&byline=0&portrait=0&background=0&loop=0&autopause=0`;

      iframe.setAttribute('src', videoSrc);
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      );
      iframe.setAttribute('id', 'video-player');
      iframe.setAttribute('class', 'absolute top-0 left-0 w-full h-full video');

      embedContainer.innerHTML = ''; // Clear existing content
      embedContainer.appendChild(iframe);

      if (platform === 'youtube') {
        // Initialize YouTube Player API
        player = new YT.Player(iframe, {
          events: {
            onReady: () => console.log('YouTube Player Ready'),
            onStateChange: (event) => console.log('YouTube Player State Changed'),
          },
        });
      } else if (platform === 'vimeo') {
        // Initialize Vimeo Player API
        player = new Vimeo.Player(iframe);
        player.play();
      }
    });

    closeBtn.addEventListener('click', function () {
      if (player) {
        if (platform === 'youtube' && typeof player.stopVideo === 'function') {
          player.stopVideo(); // Stop YouTube video
        } else if (platform === 'vimeo' && typeof player.pause === 'function') {
          player.pause(); // Pause Vimeo video
        }
      }
      embedContainer.innerHTML = ''; // Clear the iframe
    });
  }

  // Initialize Vimeo players
  document.querySelectorAll('[class*=cms-vimeo]').forEach(function (vimeo_vid) {
    const videoText = vimeo_vid.closest('[id^="data-video-"]');
    const embedContainer = vimeo_vid.querySelector('#embed-video');
    const videoId = embedContainer.getAttribute('data-id');
    const videoIdMobile = embedContainer.getAttribute('data-id-mobile');
    const playBtn = videoText.querySelector('#playbtn-cms');
    const closeBtn = videoText.querySelector('.close');

    initializeVideoPlayer({
      platform: 'vimeo',
      videoElement: vimeo_vid,
      videoId,
      videoIdMobile,
      embedContainer,
      playBtn,
      closeBtn,
    });
  });

  // Initialize YouTube players
  document.querySelectorAll('[class*=cms-youtube]').forEach(function (yt_vid) {
    const videoText = yt_vid.closest('[id^="data-video-"]');
    const embedContainer = yt_vid.querySelector('#embed-video');
    const videoId = embedContainer.getAttribute('data-id');
    const videoIdMobile = embedContainer.getAttribute('data-id-mobile');
    const playBtn = videoText.querySelector('#playbtn-cms');
    const closeBtn = videoText.querySelector('.close');

    initializeVideoPlayer({
      platform: 'youtube',
      videoElement: yt_vid,
      videoId,
      videoIdMobile,
      embedContainer,
      playBtn,
      closeBtn,
    });
  });
});